// extracted by mini-css-extract-plugin
export default {"main":"DayCarer_main__chpgK","formDiv":"DayCarer_formDiv__lXHMs","form":"DayCarer_form__vftM3","input":"DayCarer_input__l2HMm","select":"DayCarer_select__pGP7H"};